import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";

import LocationForm from "Components/Form/LocationForm";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import BankForm from "Components/Form/BankForm";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import {
  useGetBankByIdQuery,
  useUpdateBankMutation,
} from "AppQuries/master/Bank/bank";
import { bankValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
const EditBank = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: bankData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetBankByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  const {
    mutate: updateBank,
    isPending,
    isError,
    error,
  } = useUpdateBankMutation();
  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(bankValidationSchema),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    updateBank(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Bank Master Updated Successfully.");
          // setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.bank}`);
          // }, 1000);
        } else {
          toast.success("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.success(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    console.log("bankData",bankData)
    if (Array.isArray(bankData) && bankData.length > 0) {
      Object.keys(bankData[0]).forEach((key) => {
        setValue(key, bankData[0][key]);
      });
    }
  }, [bankData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div className="page-wrapper">
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Edit Bank Master</h4>
                  <h6>Edit your Bank Master </h6>
                </div>
              </div>
              
              <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Update</Tooltip>}
                >
                  <button type="submit" className="btn btn-added">
                    <Save className="me-2" />
                    Update
                  </button>
                </OverlayTrigger>
              </div>
               <div className="page-btn">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.master}${all_routes.bank}`}
                    className="btn btn-secondary"
                  >
                    <BackIcon className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </div>
             
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card border-0">
                  <div className="card-body">
                    <BankForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default EditBank;
